import { themes } from '../../../constants';
import { B2BMenu } from './B2BMenu';
import { B2CMenu } from './B2CMenu';
export var Menu = function Menu(_ref) {
  var accordionExpandedItems = _ref.accordionExpandedItems,
      navigation = _ref.navigation,
      navigationFavorites = _ref.navigationFavorites,
      onClose = _ref.onClose,
      setSubmenu = _ref.setSubmenu,
      theme = _ref.theme,
      toggleAccordionItem = _ref.toggleAccordionItem;

  switch (theme) {
    case themes.b2b:
      return B2BMenu({
        navigation: navigation,
        onClose: onClose,
        theme: theme,
        toggleAccordionItem: toggleAccordionItem,
        accordionExpandedItems: accordionExpandedItems,
        setSubmenu: setSubmenu
      });

    default:
      return B2CMenu({
        accordionExpandedItems: accordionExpandedItems,
        navigation: navigation,
        navigationFavorites: navigationFavorites,
        setSubmenu: setSubmenu,
        onClose: onClose,
        toggleAccordionItem: toggleAccordionItem
      });
  }
};